// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex';
import axios from 'axios'
import VueAxios from "vue-axios";
Vue.prototype.$ajax = axios;
Vue.config.productionTip = false
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import QRCode from 'qrcodejs2'
Vue.prototype.$QRCode = function() {
    let qrcode = new QRCode('qrcode', {
        width: 232, // 设置宽度
        height: 232, // 设置高度
        text: '12345',
    });
};
Vue.use(VXETable)

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(ElementUI)

Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store, //使用store
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js